import { useLocation } from 'react-router-dom';

export default function useLocationQuery() {
  const location = useLocation();
  return new URLSearchParams(location.search);
}
